import createHistory from 'history/createBrowserHistory'; // eslint-disable-line

export default createHistory({
	forceRefresh: true,
});
